import { Button, Card, Col, Empty, Form, Input, Modal, Row, Select, Spin } from 'antd';
import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalOptions, ServiceOperationCode } from '../../../models/appModels';
import { CommonService, Constant } from '../../../services/services';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from "react-virtualized";
export interface OperrationCodeModalOptions extends ModalOptions<ServiceOperationCode> {
}

const ModelSearch = (props: OperrationCodeModalOptions) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [cache, setCache] = useState<CellMeasurerCache>(new CellMeasurerCache({
        fixedWidth: true,
        defaultHeight: 100
    }));

    const modelSearchFrom = "modelSearchForm"
    const modalClass = "vertical-modal"

    const closeForm = () => {
        props.handleCancel()
    }

    const calculateScrollMaxHeight = (gridId: string, modalClass: string) => {
        return CommonService.calculateScrollMaxHeight(gridId, modalClass)
    }

    const calculateScrollHeight = () => {
        document.documentElement.style.setProperty(Constant.cssVariables.ModalHeightScrollList, calculateScrollMaxHeight(modelSearchFrom, modalClass));
    }

    useEffect(() => {
        calculateScrollHeight()
    }, [])

    const onOpCodeClick = (opCode: ServiceOperationCode) => {
        props.handleCancel(opCode)
    };

    const renderItem = ({ index, key, style, parent }: any) => {
        const item = props.objectData[index];
        return (
            <CellMeasurer
                key={key}
                cache={cache}
                parent={parent}
                columnIndex={0}
                rowIndex={index}>
                <div key={key} style={style} onClick={() => onOpCodeClick(item) }>
                    <Card className="card-selection">
                        <Row>
                            <Col xs={{ span: 12 }}>
                                <label className="title-field">{t("service_management.dms_operation_code")}</label>
                                <label className="text-field semi-bold-text">{item.DmsOperationCode}</label>
                            </Col>                          
                            <Col xs={{ span: 12 }}>
                                <label className="title-field">{t("service_management.codebook_source_code")}</label>
                                <label className="text-field truncate semi-bold-text">{item.DmsCodebookSourceName}</label>
                            </Col>
                            <Col xs={{ span: 24 }}>
                                <label className="title-field">{t("common.description")}</label>
                                <label className="text-field semi-bold-text">{item.Description}</label>
                            </Col>
                        </Row>
                    </Card>
                </div>

            </CellMeasurer>
        );
    };

    const rowHeightCalc = (idx: any) => {
        return cache.rowHeight(idx) + 10
    }
    return (
        <Modal
            title={t("vehicle_detail.model_selection")}
            visible={true}
            onOk={form.submit}
            confirmLoading={false}
            onCancel={closeForm}
            okText={t("common.ok")}
            cancelText={t("common.cancel")}
            className={`portal-modal modal-open ${modalClass}`}
            maskClosable={false}
            footer={null}
            transitionName=""
            maskTransitionName=""
        >
            {props.objectData && props.objectData.length > 0 &&
                <div className="list-container">
                    <AutoSizer>
                        {({ width, height }) => {
                            return <List
                                width={width}
                                height={height}
                                rowHeight={rowHeightCalc}
                                deferredMeasurementCache={cache}
                                rowRenderer={renderItem}
                                rowCount={props.objectData.length}
                                overscanRowCount={3}
                            />
                        }
                        }
                    </AutoSizer>
                </div>
            }
        </Modal>

    )
}

export default ModelSearch